import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "delivery-new" }

import {computed, ref, watch} from 'vue';
import Error from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import {ProviderStatus} from '@/model/Provider';
import Provider from '@/model/Provider';
import router from '@/router';
import DatePicker from '@/components/DatePicker.vue';
import moment from 'moment';
import {doAlert} from '@/util';
import {getProviders} from '@/api/module/provider';
import {ValueType} from '@/api/meta/filters';
import {VNodeRef} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PicklistCreate',
  setup(__props, { expose: __expose }) {

const kunde = ref<{ value: string; text: string, name: string } | null>(null);
const Lieferdatum = ref(moment().format('YYYY-MM-DD'));
const formValid = ref(false);
const kundenLoaded = ref(false);
const kunden = ref<Provider[]>([]);
const debounceKundenTimeout = ref<NodeJS.Timeout | null>(null);
const kundenSearchWord = ref('');
const kundenLoading = ref(false);
const form = ref<HTMLFormElement & VNodeRef | undefined>();

const kundenItems = computed(() => {
  return kunden.value.map((l) => ({
    value: String(l.KundenNr),
    text: `${l.Kundname} [${l.KundenNr}]`,
    name: l.Kundname,
  }));
});

function ruleRequired(val: string | null | undefined): string | true {
  if (!val) return 'erforderlich';

  return true;
}

async function loadKunden() {
  if (!kundenSearchWord.value) {
    kundenLoading.value = false;
    return;
  }
  try {
    [kunden.value] = await getProviders({
      KundStatus$In: [ProviderStatus.Kunden],
      Fulltext$Fulltext: {
        words: [String(kundenSearchWord.value)],
        fields: [
          {path: ['KundenNr'], valueType: ValueType.Naked},
          {path: ['Kundname'], valueType: ValueType.StringContains},
        ],
      },
    }, []);
  } finally {
    kundenLoading.value = false;
  }
}

async function save() {
  try {
    form.value?.validate();
    if (!formValid.value) throw new Error('Bitte alle Felder korrekt ausfüllen');

    router.push({path: '/picklist/-1', query: {kunde: kunde.value!.value, liferdatum: Lieferdatum.value}}).catch(console.error);
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  }
}

watch(kundenSearchWord, () => {
  kundenLoading.value = true;

  if (debounceKundenTimeout.value) clearTimeout(debounceKundenTimeout.value);
  debounceKundenTimeout.value = setTimeout(loadKunden, 500);
});

watch(form, () => {
  form.value?.validate();
});

__expose({
  Error, Loading, DatePicker,
  kunde,
  Lieferdatum,
  formValid,
  kundenLoaded,
  kunden,
  debounceKundenTimeout,
  kundenSearchWord,
  kundenLoading,
  form,
  save,
  ruleRequired,
});


return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          modelValue: formValid.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValid).value = $event)),
          ref: form.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_autocomplete, {
              modelValue: kunde.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((kunde).value = $event)),
              items: kundenItems.value,
              "item-title": "text",
              label: "Kunde",
              rules: [ruleRequired],
              search: kundenSearchWord.value,
              "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((kundenSearchWord).value = $event)),
              loading: kundenLoading.value,
              "return-object": true,
              required: ""
            }, null, 8, ["modelValue", "items", "rules", "search", "loading"]),
            _createVNode(DatePicker, {
              class: "mt-5",
              modelValue: Lieferdatum.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((Lieferdatum).value = $event)),
              label: "Lieferdatum",
              rules: [ruleRequired]
            }, null, 8, ["modelValue", "rules"]),
            _createVNode(_component_v_btn, {
              color: "primary",
              onClick: save,
              disabled: !formValid.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("Erstellen")
              ], undefined, true),
              _: 1
            }, 8, ["disabled"])
          ], undefined, true),
          _: 1
        }, 8, ["modelValue"])
      ], undefined, true),
      _: 1
    })
  ]))
}
}

})